import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MatStepper} from '@angular/material';
import {DelegationListComponent} from '../delegation-list/delegation-list.component';
import { DelegationHabilitationParams } from 'app/modules/delegation/delegation.model';
import { DatePipe } from '@angular/common';
import {DelegationService} from '../delegation.service';

@Component({
  selector: 'app-authorization-delegation',
  templateUrl: './authorization-delegation.component.html',
  styleUrls: ['./authorization-delegation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuthorizationDelegationComponent implements OnInit, AfterViewInit {
  constructor(private _formBuilder: FormBuilder,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<DelegationListComponent>,
              private datePipe: DatePipe,
              private delegationService: DelegationService) { }
  @ViewChild('stepper') private myStepper: MatStepper;

  color = 'accent';
  checked = false;
  panelOpenState = false;
  todayDate = new Date();

  @Input()
  habilitation: any;

  startDate: Date;

  endDate: Date;

  @Input()
  selectedDelagtor;

  @Output() authorizationEmitter = new EventEmitter<any>();

  @Output() toggleEmitter = new EventEmitter<boolean>();



  ngOnInit() {
    this.delegationService.selectAllHabilitationsSubject$.subscribe(isChecked => {
      this.panelOpenState = isChecked;
    });
    if (this.selectedDelagtor.delegator.delegationHabilitation.delegationHabilitationParamsVO.id === this.habilitation.id ) {
      this.panelOpenState = true;
      this.startDate = this.selectedDelagtor.delegator.delegationHabilitation.startDate;
      this.endDate = this.selectedDelagtor.delegator.delegationHabilitation.endDate;
    } else {
      this.panelOpenState = false;
    }
    // this.emitHabilitationsData();
  }
  ngAfterViewInit() {

  }

  toggleChanged() {
    this.panelOpenState = !this.panelOpenState ;
    this.delegationService.selectHabilitationItemSubject$.next(this.panelOpenState);
    this.emitHabilitationsData(null,null);
    this.toggleEmitter.emit(this.panelOpenState);
  }

  emitHabilitationsData(event, typeDate) {
    let startDate = event && typeDate == "startDate"? event : this.startDate;
    let endDate = event && typeDate == "endDate"? event : this.endDate;
    const delegationHabilitation: DelegationHabilitationParams = {
        id: this.habilitation.id,
        label: this.habilitation.label,
        title: this.habilitation.title,
        startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
        endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
        activate: this.panelOpenState
      };
      // if (this.startDate && this.endDate) {
        this.authorizationEmitter.emit(delegationHabilitation);
      // }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/authorization-delegation/authorization-delegation.component.ts